<header
  [ngClass]="{
    'section-header': true,
    'is-multiline': isMultiline(),
    'is-modal-head': isModalHead(),
  }"
>
  <ng-content></ng-content>
</header>
